<template>
    <f7-page color-theme="teal" name="addevent" >
        <f7-navbar title="Add event">
            <f7-nav-right>
                <f7-link icon-if-ios="f7:menu" icon-if-md="material:menu" panel-open="right"></f7-link>
            </f7-nav-right>
        </f7-navbar>
    <f7-list no-hairlines-md form>

        <f7-list-input
                label="Jobgroup"
                type="select"
                :value="todoCustomItem.jobgroupID"
                @input="todoCustomItem.jobgroupID = $event.target.value"
                :required="true"
                :validate="errors.jobgroupID"
                :error-message="(errors.jobgroupID ? 'Job Group is required.' : '')"
                :error-message-force="true"
        >
            <option value="">Please select a Job Group</option>
            <option v-for="(jobgroup) in jobgroup" :key="jobgroup.ID"
                    :value="jobgroup.ID" >{{ jobgroup.description }}</option>
        </f7-list-input>


        <f7-list-input
                label="Todo group"
                type="select"
                :value="todoCustomItem.todogroupID"
                @input="todoCustomItem.todogroupID = $event.target.value"
                :required="true"
                :validate="errors.todogroupID"
                :error-message="(errors.todogroupID ? 'Todo Group is required.' : '')"
                :error-message-force="true"
        >
            <option value="">Please select a Todo Group</option>
            <option v-for="(group,id) in todo.groups" :key="id"
                    :value="id" >{{ group.name }}</option>
        </f7-list-input>

        <f7-list-input
                label="Description"
                type="text"
                placeholder="Add description"
                :value="todoCustomItem.description"
                @input="todoCustomItem.description = $event.target.value"
                :required="true"
                :validate="errors.description"
                :error-message="(errors.description ? 'Description is required.' : '')"
                :error-message-force="true"
                clear-button
        ></f7-list-input>

        <f7-list-input
            label="Date"
            type="date"
            :value="todoCustomItem.date"
            @input="todoCustomItem.date = $event.target.value"
            :required="true"
            :validate="errors.date"
            :error-message="(errors.date ? 'Date is required.' : '')"
            :error-message-force="true"
            placeholder="Please choose..."
        >
        </f7-list-input>

        <f7-block>
            <f7-row tag="p">
                <f7-col tag="span">
                    <f7-button raised big fill @click.prevent="saveEvent" color-theme="teal">Save Event</f7-button>
                </f7-col>
            </f7-row>
        </f7-block>
    </f7-list>
    </f7-page>
</template>

<script>
    export default {
        data() {
            return {
                todos:[],
                tokenValue: {},
                token: localStorage.getItem('token'),
                user: {},
                todoCustomItem: {
                    date: new Date().toISOString().substr(0,10),
                    description: '',
                    jobgroupID: '',
                    todogroupID: ''
                },
                errors: {}
            }
        },
        watch: {
            isAuth(val) {
                if(val==false) {
                    this.$f7router.navigate('/login');
                }
            },
            customitemerror(val) {
                this.errors = val.body;
            }
        },
        computed:{
            isAuth() {
                return this.$store.getters['admin/isAuth']
            },
            todo() {
                return this.$store.getters['todo/getTodo']
            },
            jobgroup() {
                return this.$store.getters['jobgroup/getJobGroup']
            },
            customitemerror() {
                return this.$store.getters['todo/getCustomItemResponse']
            }
        },
        methods: {
            getTodo() {
                this.tokenValue = this.$parseJWT(this.token);
                this.$store.dispatch('todo/getTodo',this.tokenValue);
            },
            getJobGroup() {
                this.tokenValue = this.$parseJWT(this.token);
                this.$store.dispatch('jobgroup/getJobGroup',this.tokenValue);
            },
            saveEvent() {
                var $$ = this.Dom7;
                this.$store.dispatch('todo/addCustomItem',this.todoCustomItem);
                if ($$('form')[0].checkValidity()) {
                    this.$f7router.navigate('/todo');
                }
            }
        },
        mounted() {
            localStorage.removeItem('edit');
            this.getTodo();
            this.getJobGroup();
        }
    };

</script>